<template>

    <trax-ui-ajax-form-in-modal :id="id" :toastr-id="toastrId" :endpoint="endpoint"
        :props="props" :titles="titles" :bus="bus" :form="form" icons="1">

        <trax-ui-input type="text" icon="text_fields" :placeholder="lang.polaris.form.name"
            v-model="form.name" :error="errors.name" required="1">
        </trax-ui-input>

        <!-- The image is uploaded right after the background is recorded. -->

        <trax-ui-dropzone
            v-model="file"
            :url="endpoint"
            :options="options"
            @addedfile="addedFile"
            @error="uploadError"
            @success="uploadSuccess"
            preview-classes="trax-background-preview"
            image-preview-classes="trax-background-preview-image"
        ></trax-ui-dropzone>

        <div class="trax-form-notice trax-form-notice-dropzone">
            {{ lang.polaris.settings.background_image_notice }}
        </div>

        <!-- Backgrounds are never deleted: they are disabled to leave the select lists. -->

        <trax-ui-toggle :text="lang.polaris.settings.background_enabled" v-model="form.active">
        </trax-ui-toggle>

        <div class="trax-form-notice trax-form-notice-toggle text-warning">
            {{ lang.polaris.settings.background_delete_notice }}
        </div>

    </trax-ui-ajax-form-in-modal>

</template>

<script>
    export default {

        props: ['bus', 'id', 'toastrId', 'previewId', 'endpoint'],

        data: function() {
            return {
                lang: lang,
                form: {},
                errors: {},
                file: null,
                dropzone: null,
                props: {
                    id: { source:'id' },
                    name: { source:'name' },
                    active: { source:'active', default:true }
                },
                titles: {
                    new: lang.polaris.settings.new_background,
                    update: lang.polaris.settings.background_update
                },
                options: {
                    autoProcessQueue: false,
                    acceptedFiles: 'image/jpeg,image/png,image/gif',
                    thumbnailWidth: 400,
                    thumbnailHeight: 120,
                    resizeWidth: 2000,
                    resizeQuality: 0.9,
                    resizeMethod: 'contain',
                    resizeMimeType: 'image/jpeg',
                }
            }
        },

        created: function() {
            var that = this;

            this.bus.$on(that.id+'-errors', function(errors) {
                that.errors = errors;
            });

            this.bus.$on(that.id+'-data', function(data) {
                that.form = data;
                that.clearFile();
            });

            // The image can only be sent once the background exists: the form
            // records it first, then the file goes to the image endpoint.

            this.bus.$on(that.id+'-created', that.uploadImage);
            this.bus.$on(that.id+'-updated', that.uploadImage);
        },

        methods: {

            addedFile(event) {
                this.dropzone = event.dropzone;
            },

            clearFile() {
                this.file = null;
                if (this.dropzone) {
                    this.dropzone.removeAllFiles();
                }
            },

            uploadImage(request) {
                if (!this.file || !this.dropzone) {
                    return;
                }
                var id = request.response.data.data.id;
                this.dropzone.options.url = this.endpoint + '/' + id + '/image';
                this.$bus.$emit('loader-start-loading');
                this.dropzone.processQueue();
            },

            uploadSuccess(event) {
                this.clearFile();
                this.$bus.$emit('loader-stop-loading');
                this.bus.$emit(this.toastrId+'-success', this.lang.polaris.settings.background_image_uploaded);

                // Show the new image in the preview card.
                this.bus.$emit(this.previewId, event.args[1].data);

                // Refresh the table: this is the event it listens to.
                this.bus.$emit(this.id+'-updated');
            },

            uploadError(event) {
                this.$bus.$emit('loader-stop-loading');
                this.bus.$emit(this.toastrId+'-error', this.lang.polaris.settings.background_image_error);
            }
        }

    }
</script>
